<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="1000px">
      <v-form ref="PerformanceTarget" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>{{ action }} Support Function</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="success_indicator"
                    :disabled="data && data.func_type == 3"
                    dense
                    outlined
                    label="Success Indicator"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="actual_accom"
                    dense
                    outlined
                    label="Actual Accomplishment"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="mt-4">
                  <div class="rounded-lg pa-3" style="border: 1px solid gray">
                    <div class="h3 mb-2">
                      <!-- Performance Target
                      Success Indicator (Target + Measure) -->
                      Rating (<i>Uncheck if <b>Not to be Rated</b></i> )
                    </div>
                    <v-row>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          :readonly="data && data.func_type == 3"
                          v-model="eff_is_rated"
                          label="(E) - Efficiency"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          :readonly="data && data.func_type == 3"
                          v-model="qly_is_rated"
                          label="(Q) - Quality"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          :readonly="data && data.func_type == 3"
                          v-model="timeliness_is_rated"
                          label="(T) - Timeliness"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <!-- <v-col
                  cols="12"
                  class="mt-2 py-2 px-3"
                  v-if="data && data.func_type != 1"
                >
                  <div class="pa-2 rounded-lg" style="border:1px solid grey">
                    <div class="text-h6 py-2">Attachment</div>

                    <v-btn
                      v-if="!getIsFileSelected"
                      color="#519043"
                      outlined
                      @click="showFileUpload()"
                      >Upload Attachment</v-btn
                    >
                    <v-btn
                      v-if="getIsFileSelected"
                      color="#519043"
                      class="mx-1 white--text"
                      @click="viewFile()"
                      >View Attachment</v-btn
                    >

                    <v-btn
                      v-if="getIsFileSelected"
                      class="mx-1"
                      color="warning"
                      @click="reupload()"
                      >Reupload File</v-btn
                    >
                  </div>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>

            <v-btn
              v-if="action == 'Update'"
              color="#519043"
              class="white--text"
              @click="save()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="fileUploadDialog"
      transition="dialog-bottom-transition"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <span>{{ uploadFileAction }} Attachment</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="fileUploadDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4">
          <v-form @submit.prevent ref="AttachmentFormref">
            <v-row>
              <v-col cols="12">
                <v-file-input
                  v-model="file_selected"
                  :rules="[formRules.required, formRules.isPDF]"
                  accept="application/pdf"
                  outlined
                  color="#6DB249"
                  dense
                  label="Upload file"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn outlined color="red" @click="fileUploadDialog = false"
            >cancel</v-btn
          >
          <v-btn
            class="white--text"
            :color="$vuetify.theme.themes.light.submitBtns"
            @click="saveAttachment()"
            :disabled="isAttachmentBtnLoading"
            :loading="isAttachmentBtnLoading"
            >save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    target_type: null,
    ipcrID: null,
    action: null,
  },

  data() {
    return {
      id: null,
      success_indicator: null,
      actual_accom: null,
      timeliness: null,
      quality: null,
      efficiency: null,
      efficiency_type: null,
      eff_is_rated: true,
      qly_is_rated: true,
      timeliness_is_rated: true,
      dialog: false,
      isSubmitLoading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mfoList: ["Core Functions", "Strategic Priority", "Support Functions"],
      mfo: null,
      mfoDescription: null,
      fileUploadDialog: false,
      uploadFileAction: null,
      isAttachmentBtnLoading: false,
      file_selected: null,
      prevFile: null,
      fileToSave: null,
    };
  },
  computed: {
    getIsFileSelected() {
      let toReturn = false;

      if (this.data && this.data.ipcr_support_attachment) {
        toReturn = true;
      } else {
        if (this.fileToSave) {
          return true;
        }
      }

      return toReturn;
    },
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("asdasdad", data);
        this.uploadFileAction = null;
        this.prevFile = null;
        if (data.id) {
          this.id = data.id;
          this.mfo = data.mfo;
          this.success_indicator = data.suc_ind;
          this.actual_accom = data.actual_accom;
          this.timeliness = data.timeliness;
          this.quality = data.quality;
          this.efficiency = data.efficiency;
          this.efficiency_type = data.efficiency_type;
          this.eff_is_rated = data.eff_is_rated;
          this.qly_is_rated = data.qly_is_rated;
          this.timeliness_is_rated = data.timeliness_is_rated;
          this.file_selected = data.ipcr_support_attachment
            ? data.ipcr_support_attachment.filename
            : null;
          this.fileToSave = null;
        } else {
          this.id = null;
          this.mfo = null;
          this.actual_accom = null;
          this.timeliness = null;
          this.efficiency_type = null;
          this.quality = null;
          this.efficiency = null;
          this.eff_is_rated = 1;
          this.qly_is_rated = 1;
          this.timeliness_is_rated = 1;
          this.file_selected = null;
          this.fileToSave = null;
        }
      },

      deep: true,
    },
  },

  methods: {
    initialize() {},
    getMFODesc(id) {
      return this.mfoList[id - 1];
    },
    closeD() {
      this.eventHub.$emit("closeUpdateSupportFunctionDialog", false);
      this.initialize();
      this.isSubmitLoading = false;
      this.dialog = false;
    },

    showFileUpload() {
      this.file_selected = null;
      this.fileUploadDialog = true;
      this.uploadFileAction = "Add";
    },
    reupload() {
      this.prevFile = this.file_selected;
      this.file_selected = null;
      this.fileUploadDialog = true;
      this.uploadFileAction = "Update";
    },

    viewFile() {
      if (this.uploadFileAction == "Add") {
        const objectURL = URL.createObjectURL(this.fileToSave);
        window.open(objectURL, "_blank");
      } else {
        if (this.prevFile) {
          const objectURL = URL.createObjectURL(this.file_selected);
          window.open(objectURL, "_blank");
        } else {
          let url =
            process.env.VUE_APP_SERVER +
            "/ipcr-support/previewFile/" +
            this.file_selected;

          let token = localStorage.getItem("token");
          const tab = window.open("about:blank");
          this.isLoading = true;
          fetch(url, { headers: { Authorization: `Bearer ${token}` } })
            .then((response) => response.blob())
            .then((blob) => {
              var _url = window.URL.createObjectURL(blob);

              tab.location = _url;
              tab.focus();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },

    saveAttachment() {
      this.isAttachmentBtnLoading = true;

      if (this.$refs.AttachmentFormref.validate()) {
        this.isAttachmentBtnLoading = false;
        this.prevFile = this.data.ipcr_support_attachment
          ? this.data.ipcr_support_attachment.filename
          : "prevFile";
        this.fileToSave = this.file_selected;
        this.fileUploadDialog = false;
      }
    },

    // addnew() {
    //   if (this.$refs.SupportFunction.validate()) {
    //     this.isSubmitLoading = true;
    //     let data = {
    //       selectedType: this.selectedType,
    //       year: this.year,
    //       selectedPrevYear:
    //         this.selectedType == 2 ? this.selectedPrevYear : null,
    //       success_indicator: this.success_indicator,
    //       actual_accom: this.actual_accom,
    //       func_type: this.func_type,
    //       eff_is_rated: this.eff_is_rated,
    //       qly_is_rated: this.qly_is_rated,
    //       timeliness_is_rated: this.timeliness_is_rated,
    //       sf_for: this.tab == 1 ? "non-teaching" : "teaching",
    //     };
    //     // console.log(data);
    //     this.axiosCall("/ipcr-support-util", "POST", data).then((res) => {
    //       if (res.data.status == 201) {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "success";
    //         this.fadeAwayMessage.header = "System Message";
    //         this.fadeAwayMessage.message = res.data.msg;

    //         this.closeD();
    //       } else {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "error";
    //         this.fadeAwayMessage.header = "System Message";
    //         this.fadeAwayMessage.message = res.data.msg;
    //       }
    //     });
    //   }
    // },

    save() {
      if (this.$refs.PerformanceTarget.validate()) {
        // if (this.prevFile) {
        //   this.isSubmitLoading = true;
        //   let data = {
        //     ipcr_ID: this.ipcrID,
        //     actual_accom: this.actual_accom,
        //     suc_ind: this.success_indicator,
        //     eff_is_rated: this.eff_is_rated,
        //     qly_is_rated: this.qly_is_rated,
        //     timeliness_is_rated: this.timeliness_is_rated,
        //   };
        //   let fd = new FormData();
        //   fd.append("data", JSON.stringify(data));
        //   fd.append("file", this.file_selected);

        //   fd.append(
        //     "prevFile",
        //     this.prevFile != "prevFile"
        //       ? this.data.ipcr_support_attachment.filename
        //       : null,
        //   );

        //   // console.log(data);
        //   this.axiosCall(
        //     "/ipcr-support/updateSupportFunctionReuploadFile/" + this.id,
        //     "PATCH",
        //     fd,
        //   ).then((res) => {
        //     console.log(res);
        //     if (res.data.status == 200) {
        //       this.fadeAwayMessage.show = true;
        //       this.fadeAwayMessage.type = "success";
        //       this.fadeAwayMessage.header = "System Message";
        //       this.fadeAwayMessage.message = res.data.msg;

        //       this.closeD();
        //     } else {
        //       this.fadeAwayMessage.show = true;
        //       this.fadeAwayMessage.type = "error";
        //       this.fadeAwayMessage.header = "System Message";
        //       this.fadeAwayMessage.message = res.data.msg;
        //     }
        //   });
        // } else {
        // if (this.data.ipcr_support_attachment) {
        this.isSubmitLoading = true;
        let data = {
          ipcr_ID: this.ipcrID,
          actual_accom: this.actual_accom,
          suc_ind: this.success_indicator,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
        };
        // console.log(data);
        this.axiosCall(
          "/ipcr-support/updateSupportFunction/" + this.id,
          "PATCH",
          data,
        ).then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;

            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
        // } else {
        //   this.fadeAwayMessage.show = true;
        //   this.fadeAwayMessage.type = "error";
        //   this.fadeAwayMessage.header = "System Message";
        //   this.fadeAwayMessage.message = "Attachment is required!";
        // }
        // }
      }
    },

    getEmpDetails() {
      this.axiosCall("/employee/my-details", "GET").then((res) => {
        console.log(res.data);
        this.assigned_office = res.data.officeID;
      });
    },

    getOffices() {
      this.axiosCall("/offices", "GET").then((res) => {
        this.officeList = res.data;
      });
    },

    getDesignations() {
      this.axiosCall("/designations", "GET").then((res) => {
        this.designationList = res.data;
      });
    },
  },
};
</script>
